import { OR, UID_IN } from 'shared/api/query/constants';
import { notHasFilter } from 'shared/api/query/filter';

export const directPropGoalCycleFn = (isFilterMode = false) => (scope) => {
  if (scope.isEmpty === true) {
    return {
      filterTrees: [notHasFilter(scope.directProperty.edgeName)],
      varBlocks: [],
    };
  }

  const goalCycles = scope.goalCycles || [];
  if (goalCycles.length === 0 && isFilterMode) {
    return { filterTrees: [], varBlocks: [] };
  }

  return {
    filterTrees: [
      {
        op: OR,
        child: [{
          func: {
            attr: scope.directProperty.edgeName,
            name: UID_IN,
            args: goalCycles.map((c) => ({ value: `${c.uid}` })),
          },
        }],
      },
    ],
    varBlocks: [],
  };
};
